import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column" }
const _hoisted_2 = ["onSubmit"]
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "d-flex justify-content-end" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["onClick", "data-kt-indicator", "disabled"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Submit ", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormField = _resolveComponent("FormField")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Form, {
      "validation-schema": _ctx.formSchema,
      initialValues: _ctx.formData,
      ref: "drawUpdateForm"
    }, {
      default: _withCtx(({ handleSubmit, values, validate }) => [
        _createElementVNode("form", {
          onSubmit: _withModifiers(($event: any) => (handleSubmit(values, _ctx.submitDrawForm)), ["prevent"]),
          class: "form w-100 fv-plugins-bootstrap5 fv-plugins-framework",
          id: "update-draw-form",
          novalidate: "",
          enctype: "multipart/form-data"
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_FormField, {
              required: true,
              name: _ctx.addPrefix('title', _ctx.prefix),
              containerClass: "col-lg-4 col-md-4 col-6",
              label: "Title",
              placeholder: "Title"
            }, null, 8, ["name"]),
            _createVNode(_component_FormField, {
              required: true,
              name: _ctx.addPrefix('prize', _ctx.prefix),
              containerClass: "col-lg-4 col-md-4 col-6",
              label: "Prize",
              placeholder: "Prize",
              type: "text"
            }, null, 8, ["name"]),
            _createVNode(_component_FormField, {
              containerClass: "col-lg-4 col-md-4 col-12",
              label: "Type",
              name: _ctx.addPrefix('type', _ctx.prefix),
              options: _ctx.drawOptions,
              required: true,
              selectValue: values.type,
              onSelectChange: _ctx.handleChangeType,
              onSelectCloseOrDeselect: _ctx.handleCloseType,
              type: "multiselect",
              "show-label": true
            }, null, 8, ["name", "options", "selectValue", "onSelectChange", "onSelectCloseOrDeselect"]),
            _createVNode(_component_FormField, {
              required: true,
              name: _ctx.addPrefix('draw_date', _ctx.prefix),
              containerClass: "col-lg-4 col-md-4 col-6",
              label: "Draw Date",
              placeholder: "Draw Date",
              type: "datepicker",
              dateFormat: "DD/MM/YYYY"
            }, null, 8, ["name"]),
            _createVNode(_component_FormField, {
              required: true,
              name: _ctx.addPrefix('draw_time', _ctx.prefix),
              containerClass: "col-lg-4 col-md-4 col-6",
              label: "Draw Time",
              placeholder: "Draw Time",
              type: "timepicker",
              timeFormat: "hh:mm A"
            }, null, 8, ["name"]),
            _createVNode(_component_FormField, {
              required: false,
              name: _ctx.addPrefix('description', _ctx.prefix),
              containerClass: "col-lg-12 col-md-12 col-12",
              label: "Description",
              placeholder: "Description",
              type: "textarea"
            }, null, 8, ["name"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("a", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleCancel && _ctx.handleCancel(...args))),
              class: "btn btn-white me-3",
              disabled: _ctx.loading
            }, " Cancel ", 8, _hoisted_5),
            _createElementVNode("button", {
              onClick: validate,
              "data-kt-indicator": _ctx.loading ? 'on' : null,
              class: "btn btn-lg btn-primary fw-bolder me-4",
              disabled: _ctx.loading
            }, _hoisted_9, 8, _hoisted_6)
          ])
        ], 40, _hoisted_2)
      ]),
      _: 1
    }, 8, ["validation-schema", "initialValues"])
  ]))
}